import { css } from 'styled-components';
import {
  Heading,
  OpeningHoursContainer,
  PhoneNumber,
  StyledRichText,
} from '../../../../components/SplitInfoCard/SplitInfoCardContent/styles';
import mediaQuery from '../../../../helpers/mediaQuery';
import { colors, themeSpecificColors } from '../../colors';
import { fonts, fontWeightMedium } from '../../fonts';

export default css`
  ${PhoneNumber} {
    ${fonts.paragraph}
  }

  ${OpeningHoursContainer} {
    border-top: 2px solid ${themeSpecificColors.core01_20};

    ${mediaQuery.tabletLandscape`
      border-top: 0;
      border-left-width: 2px;
    `}
  }

  ${StyledRichText} {
    b {
      font-weight: ${fontWeightMedium};
    }
  }

  ${Heading} {
    color: ${colors.neutral01};
  }
`;
